import Auth from '../../../Auth';
import useSWRInfinite from 'swr/infinite';
import usePublicMode from '../../../hooks/usePublicMode';

const extractPluginsFromResponse = res => res.plugins;
const flattenReducer = (p, c) => p.concat(extractPluginsFromResponse(c));

const fetcher = async ({ url, sort, filter, ids, searchQuery, page, limit }) => {
  const res = await Auth.fetchWithIdToken(url, {
    ids, sort, filter, searchQuery, page, limit
  });

  return res;
};

const usePlugins = ({
  sort,
  filter,
  ids,
  searchQuery,
  perPage,
}) => {
  const { urlPrefixApiPlugins } = usePublicMode();

  const getKey = (pageIndex, previousPageData) => {
    if (previousPageData && !extractPluginsFromResponse(previousPageData).length) return null; // reached the end
    return { url: `${urlPrefixApiPlugins}/api/plugins/list`, sort, filter, ids, searchQuery, page: pageIndex + 1, limit: perPage }; // SWR key
  };

  const {
    data,
    error,
    isLoading: swrLoading,
    size,
    setSize,
    isValidating,
  } = useSWRInfinite(getKey, fetcher, {
    revalidateAll: false,
    revalidateFirstPage: false,
  });

  const haveMore = data && extractPluginsFromResponse(data.at(-1)).length === perPage;
  const isLoading = swrLoading && !data;

  const plugins = data?.reduce(flattenReducer, []);
  return {
    plugins, error,
    isLoading, isValidating,
    pagesRequested: size,
    setPagesRequested: setSize,
    haveMore,
  };
};

export default usePlugins;
